import React, {FC} from 'react';
import AuthorizationForm from './AuthorizationForm';

const Authorization:FC = () => {
  return (
     <AuthorizationForm/>
  );
}

export default Authorization;